import { Component } from '@angular/core';

@Component({
  selector: 'app-app-notfound',
  templateUrl: './app-notfound.component.html',
  styleUrls: ['./app-notfound.component.scss'],
  standalone :false
})
export class AppNotfoundComponent {

}
